
<div class="container-fluid   h-[90%] mt-14 ">
  <app-appHeader></app-appHeader>
  <div class="container flex flex-row h-[100%] space-x-2 p-4 ">
    <div class="flex w-[20%] bg-white p-4 shadow-md rounded-lg border border-gray-600 " >
      <div>
        <h4>Notifications</h4>
        <app-notification-item
        (notificationSelected)="handleNotificationSelected($event)"
        ></app-notification-item>
      </div>
    </div>
  
    <div class="flex-1  p-4 pl-0 shadow-md rounded-lg w-[70%] bg-[#f4f3f6] border border-gray-600">
      <app-notification-detail [details]="selectedNotification"></app-notification-detail>
    </div>
  </div>
</div>
 